import MomentoMori from "momento-mori-calender";
import React from "react";

const Calender = () => {
  return (
    <div className="">
      <MomentoMori />
    </div>
  );
};

export default Calender;
